import PropTypes from 'prop-types';
import React, {useState, useEffect} from 'react';

function CarouselWidget(props) {
    const [state, setState] = useState({
        active: 0,
        carouselActive: true,
    });

    let activeIndex = 0;

    useEffect(() => {
        let interval = null;
        if (state.carouselActive && props.slides.length > 1) {
            interval = setInterval(() => {
                nextSlide();
            }, 5000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [state.carouselActive, props.slides]);

    const changeSlide = (index) => {
        setState({
            ...state,
            active: index,
            carouselActive: false,
        });
        activeIndex = index;
    };

    const nextSlide = () => {
        const nextSlideIndex = activeIndex === props.slides.length - 1 ? 0 : activeIndex + 1;
        setState({
            ...state,
            active: nextSlideIndex,
        });
        activeIndex = nextSlideIndex;
    };

    return (
        <div className="dashboardCarouselWidget">
            <div className="infoCarouselInnerBox">

                {
                    props.slides.map((slide, index) => {
                        return (
                            <div className={'carouselContentBox' + (state.active === index ? ' active' : '')} key={index}>
                                <h1 className="contentHeadline">{slide.title}</h1>
                                <p>{slide.text}</p>
                                <br/>
                                {slide.button && <a href={slide.btnLink} className="button outlined roundWhite">{slide.button}</a>}
                            </div>
                        );
                    })
                }

                <div className="carouselDotNavigation">
                    {
                        props.slides.map((slide, index) => {
                            return (
                                <div className={'navDot' + (state.active === index ? ' active' : '')}
                                    key={'dashboardCarouselWidget' + index}
                                    onClick={() => {
                                        changeSlide(index);
                                    }}></div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default CarouselWidget;

CarouselWidget.propTypes = {
    slides: PropTypes.array,
};

